/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseHeaderPropertiesContentBlocksInner } from './DatabaseHeaderPropertiesContentBlocksInner';
import {
    DatabaseHeaderPropertiesContentBlocksInnerFromJSON,
    DatabaseHeaderPropertiesContentBlocksInnerFromJSONTyped,
    DatabaseHeaderPropertiesContentBlocksInnerToJSON,
} from './DatabaseHeaderPropertiesContentBlocksInner';

/**
 * 
 * @export
 * @interface DatabaseHeaderProperties
 */
export interface DatabaseHeaderProperties {
    /**
     * 
     * @type {string}
     * @memberof DatabaseHeaderProperties
     */
    inlineStyle?: string;
    /**
     * Background color of the header/footer
     * @type {string}
     * @memberof DatabaseHeaderProperties
     */
    backgroundColor?: string;
    /**
     * Area is not drawn at all. Its blocks stay, so switching it back on costs nothing. Absent means shown, which keeps every existing database unchanged. Used for the page areas (pagesHeader / pagesFooter): before this flag the only way to switch an area off was to delete all of its blocks.
     * @type {boolean}
     * @memberof DatabaseHeaderProperties
     */
    hidden?: boolean;
    /**
     * Views in which this header/footer is hidden (e.g. 'LIST', 'GRID', 'GALLERY')
     * @type {Array<string>}
     * @memberof DatabaseHeaderProperties
     */
    hiddenViews?: Array<string>;
    /**
     * 
     * @type {Array<DatabaseHeaderPropertiesContentBlocksInner>}
     * @memberof DatabaseHeaderProperties
     */
    contentBlocks?: Array<DatabaseHeaderPropertiesContentBlocksInner>;
}

/**
 * Check if a given object implements the DatabaseHeaderProperties interface.
 */
export function instanceOfDatabaseHeaderProperties(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseHeaderPropertiesFromJSON(json: any): DatabaseHeaderProperties {
    return DatabaseHeaderPropertiesFromJSONTyped(json, false);
}

export function DatabaseHeaderPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseHeaderProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inlineStyle': !exists(json, 'inlineStyle') ? undefined : json['inlineStyle'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'hiddenViews': !exists(json, 'hiddenViews') ? undefined : json['hiddenViews'],
        'contentBlocks': !exists(json, 'contentBlocks') ? undefined : ((json['contentBlocks'] as Array<any>).map(DatabaseHeaderPropertiesContentBlocksInnerFromJSON)),
    };
}

export function DatabaseHeaderPropertiesToJSON(value?: DatabaseHeaderProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inlineStyle': value.inlineStyle,
        'backgroundColor': value.backgroundColor,
        'hidden': value.hidden,
        'hiddenViews': value.hiddenViews,
        'contentBlocks': value.contentBlocks === undefined ? undefined : ((value.contentBlocks as Array<any>).map(DatabaseHeaderPropertiesContentBlocksInnerToJSON)),
    };
}

